import { Button, Divider, Stack, Typography } from '@mui/joy';
import { BsArrowsAngleContract, BsArrowsAngleExpand } from 'react-icons/bs';
import { useLocation } from 'react-router-dom';

import { StimConsentPrintButton } from '@MP/features/stim-home';
import SettingIcon from '@MP/shared/icon/SettingIcon';
import { selectUser, usePatientStore } from '@MP/shared/providers/PatientProvider';
import { useGlobalUIStore } from '@MP/shared/stores/GlobalUIStore';

import MenuTabs from './MenuTabs';

const commonBarStyle = {
  borderRadius: '8px',
  px: '16px',
};

const expandedBarStyle = {
  px: '16px',
  position: 'sticky',
  left: 0,
  right: 0,
  top: 0,
};

const commonTabStyle = {
  flexGrow: 1,
};

const expandedTabStyle = {
  position: 'absolute',
  left: 0,
  right: 0,
  alignItems: 'center',
};

const PatientMenuToolBar = () => {
  const expanded = useGlobalUIStore((s) => s.expanded);
  const setExpanded = useGlobalUIStore((s) => s.setExpanded);
  const user = usePatientStore(selectUser);
  const setOpenEditDialog = usePatientStore((s) => s.setOpenEditDialog);
  const location = useLocation();

  const isStimTabActive = location.pathname.toLowerCase().startsWith('/patient/stim-home');

  return (
    <Stack position={'relative'} minHeight={55} bgcolor={'common.white'} justifyContent={'center'} borderRadius={'8px'}>
      <Stack direction={'row'} alignItems={'center'} sx={expanded ? expandedBarStyle : commonBarStyle}>
        {expanded && user && (
          <Stack
            flexGrow={1}
            direction={'row'}
            spacing={'4px'}
            divider={<Divider orientation="vertical" sx={{ height: '10px', alignSelf: 'center' }} />}>
            <Typography sx={{ fontSize: '14px' }}>{user?.birthYear}년생 </Typography>
            <Typography sx={{ fontSize: '14px' }}> {user?.name}</Typography>
          </Stack>
        )}
        <Stack sx={expanded ? expandedTabStyle : commonTabStyle}>
          <MenuTabs />
        </Stack>

        {isStimTabActive && user && <StimConsentPrintButton />}

        {user && (
          <Button
            variant="plain"
            startDecorator={<SettingIcon type="dark" width={16} />}
            color="neutral"
            onClick={() => setOpenEditDialog(true)}>
            <Typography sx={{ fontSize: '14px', fontWeight: '400' }}>환자 정보 수정</Typography>
          </Button>
        )}

        <Button
          variant="plain"
          color="neutral"
          startDecorator={expanded ? <BsArrowsAngleContract size={12} /> : <BsArrowsAngleExpand size={12} />}
          onClick={() => setExpanded(!expanded)}>
          <Typography sx={{ fontSize: '14px', fontWeight: '400' }}>{expanded ? '화면축소' : '전체화면'}</Typography>
        </Button>
      </Stack>
    </Stack>
  );
};

export default PatientMenuToolBar;
